@use "styles/mixins/_rem.scss" as rem;
@use "styles/mixins/_size.scss" as size;
@use "styles/variables/_z-index.scss" as zIndex;
@use "styles/mixins/_outline.scss" as outline;

.top-menu {
  z-index: zIndex.$top-header-z-index;
  border-bottom: size.$top-menu-border-size solid var(--color-border-subtle);
  background: var(--color-background-default);
  padding: 0 rem.torem(16px) 0 0;
  min-height: rem.torem(size.$top-menu-height);
  display: flex;
  align-items: center;

  &-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    width: 100%;

    @media (min-width: size.$desktop) {
      max-width: size.$desktop;
      margin: 0 auto;
    }
  }

  .burger-icon {
    display: flex;
    width: rem.torem(50px);
    height: rem.torem(50px);
    justify-content: center;
    align-items: center;
    gap: 24px;
    flex-shrink: 0;
  }

  @media (min-width: size.$laptop) {
    .burger-icon {
      display: none;
    }
  }

  .nav-brand {
    display: flex;

    @media screen and (min-width: size.$tablet) {
      flex-grow: 1;
    }
  }

  .logo {
    display: inline-flex;
    height: 100%;
    color: var(--color-text-default);
    width: rem.torem(80px);
    margin-left: var(--size-spacing-l);

    &:focus-visible {
      @include outline.focus-outline;

      border-radius: var(--size-border-radius-m);
    }

    &-link-disabled {
      margin-left: var(--size-spacing-l);
    }
  }
}

.top-right-menu {
  display: flex;
  align-items: center;
  gap: var(--size-spacing-xl);
}
